'use strict';

const $ = jQuery,
	$document = $( document ),
	$body = $( document.body ),
	$window = $( window );

export {
	$,
	$document,
	$body,
	$window,
};